/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../common";
import type {
  T20Logic,
  T20LogicInterface,
} from "../../../../../contracts/dependant/test/test20/T20Logic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "accessControl",
        type: "address",
      },
    ],
    name: "SetAccessControl",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "supportTransfer",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "supportMint",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "supportBurn",
        type: "bool",
      },
    ],
    name: "SetSupport",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnNormal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnSudo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amount",
        type: "uint256[]",
      },
    ],
    name: "burnSudos",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "cap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "interactAccountsContains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interactAccountsLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "interactedAccountsAt",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintNormal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintSudo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amount",
        type: "uint256[]",
      },
    ],
    name: "mintSudos",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "accessControl_",
        type: "address",
      },
    ],
    name: "setAccessControl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockListFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockListTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegeListFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegeListTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "supportTransfer_",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportMint_",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportBurn_",
        type: "bool",
      },
    ],
    name: "setSupport",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "support",
    outputs: [
      {
        internalType: "bool",
        name: "supportTransfer",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportMint",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportBurn",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transferAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transferTxs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type T20LogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: T20LogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class T20Logic__factory extends ContractFactory {
  constructor(...args: T20LogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<T20Logic> {
    return super.deploy(overrides || {}) as Promise<T20Logic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): T20Logic {
    return super.attach(address) as T20Logic;
  }
  override connect(signer: Signer): T20Logic__factory {
    return super.connect(signer) as T20Logic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): T20LogicInterface {
    return new utils.Interface(_abi) as T20LogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): T20Logic {
    return new Contract(address, _abi, signerOrProvider) as T20Logic;
  }
}
